import { AlpineComponent } from 'alpinejs';

type SearchSeminarsWidgetData = {
  ortList: string[];
  themenList: string[];
  filterOption: (type: string, event: Event) => void;
  submit: (event: Event) => void;
}

export default (ortListJson: string, themenListJson: string):AlpineComponent<SearchSeminarsWidgetData> => ({
  ortList: JSON.parse(ortListJson),
  themenList: JSON.parse(themenListJson),

  // Filter options
  filterOption(type: string, event: Event) {
    const eTarget = event.target as HTMLInputElement;
    const value = eTarget.value.toString().toLowerCase();
    let list = null;
    if (type == 'location') {
      list = Object.values(this.ortList);
    } else {
      list = Object.values(this.themenList);
    }

    if (value.length >= 2) {
      // Filter results
      const filteredResults = list.filter(item =>
        item && item.toString().toLowerCase().includes(value)
      );

      // Add results to ul list
      const ulParent = eTarget.parentElement;
      if (ulParent) {
        const list = ulParent.querySelector('ul') as HTMLUListElement;
        if (list) {
          list.innerHTML = ''; // Remove all existing li elements
          list.removeAttribute('hidden'); // Remove hidden attribute from ul

          const uniqueStates = new Set<string>();
          let isFirstItem = true;

          filteredResults.forEach(item => {
            const state = item;
            if (state && !uniqueStates.has(state)) {
              uniqueStates.add(state);

              const li = document.createElement('li');
              li.setAttribute('aria-selected', isFirstItem ? 'true' : 'false');
              isFirstItem = false;
              li.innerHTML = state.replace(new RegExp(value, 'gi'), (match: string) => `<mark>${match}</mark>`);
              li.addEventListener('click', () => {
                eTarget.value = state;
                list.setAttribute('hidden', 'hidden');
                eTarget.focus();
              });
              list.appendChild(li);
            }
          });
        }
      }
    }

    event.preventDefault();
  },

  submit(event: Event) {
    const eTarget = event.target as HTMLInputElement;
    const form = eTarget.closest('form') as HTMLFormElement;
    let actionUrl = form.dataset.action + '?date_start=&date_end=';

    const ortInput = document.querySelector('#filter-s--seminar--location') as HTMLInputElement;
    if (ortInput) {
      actionUrl += `&location=${encodeURIComponent(ortInput.value)}`;
    }
    const themenInput = document.querySelector('#filter--seminar-tag') as HTMLInputElement;
    if (themenInput) {
      actionUrl += `&post_tag=${encodeURIComponent(themenInput.value)}`;
    }

    // Redirect to url
    window.location.href = actionUrl;

    event.preventDefault();
  }
});
